'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _PostMessageTypes = require('conversations-visitor-ui/constants/PostMessageTypes');

var _Reagan = require('conversations-visitor-ui/constants/Reagan');

var _Checker = require('Reagan/components/Checker');

var _Application = require('conversations-visitor-ui/components/Application');

var _Application2 = _interopRequireDefault(_Application);

var _WidgetActions = require('conversations-visitor-ui/actions/WidgetActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _WindowActions = require('conversations-core/actions/WindowActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApplicationContainer = function (_Component) {
  _inherits(ApplicationContainer, _Component);

  function ApplicationContainer(props) {
    _classCallCheck(this, ApplicationContainer);

    var _this = _possibleConstructorReturn(this, (ApplicationContainer.__proto__ || Object.getPrototypeOf(ApplicationContainer)).call(this, props));

    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.registerContainerRef = _this.registerContainerRef.bind(_this);
    _this.onOpenUpdate = _this.onOpenUpdate.bind(_this);
    return _this;
  }

  _createClass(ApplicationContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.receiveMessage, false);
      this.onIframeResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.receiveMessage);
    }
  }, {
    key: 'registerContainerRef',
    value: function registerContainerRef(element) {
      this.containerRef = element ? (0, _reactDom.findDOMNode)(element) : null;
    }
  }, {
    key: 'getIframeDimensions',
    value: function getIframeDimensions() {
      var container = this.containerRef.getBoundingClientRect();

      return {
        width: container.width,
        height: container.height
      };
    }
  }, {
    key: 'hideWelcomeMessage',
    value: function hideWelcomeMessage() {
      parent.postMessage(JSON.stringify({
        type: _PostMessageTypes.CLOSED_WELCOME_MESSAGE
      }), '*');
    }
  }, {
    key: 'onIframeResize',
    value: function onIframeResize(size) {
      parent.postMessage(JSON.stringify({
        type: _PostMessageTypes.IFRAME_RESIZE,
        data: size || this.getIframeDimensions()
      }), '*');
    }
  }, {
    key: 'onOpenUpdate',
    value: function onOpenUpdate(isOpened) {
      this.props.toggleOpen(isOpened);
      parent.postMessage(JSON.stringify({
        type: _PostMessageTypes.OPEN_CHANGE,
        data: isOpened
      }), '*');
    }
  }, {
    key: 'requestWidget',
    value: function requestWidget() {
      parent.postMessage(JSON.stringify({
        type: _PostMessageTypes.REQUEST_WIDGET
      }), '*');
    }
  }, {
    key: 'receiveMessage',
    value: function receiveMessage(_ref) {
      var rawData = _ref.data;

      var parsedData = null;
      try {
        parsedData = JSON.parse(rawData);
      } catch (err) {
        // unparseable / unexpected message format
        return;
      }

      var _parsedData = parsedData,
          _parsedData$type = _parsedData.type,
          type = _parsedData$type === undefined ? null : _parsedData$type,
          _parsedData$data = _parsedData.data,
          data = _parsedData$data === undefined ? null : _parsedData$data;


      switch (type) {
        case _PostMessageTypes.WIDGET_DATA:
          if (data) {
            this.props.receivedWidgetData(data);
          } else {
            window.Raven.captureMessage('RECEIVED_INVALID_WIDGET_DATA', {
              extra: {
                rawData: rawData,
                parsedData: parsedData
              }
            });
          }
          break;
        case _PostMessageTypes.REQUEST_OPEN:
          this.onOpenUpdate(true);
          break;
        default:
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Application2.default, _extends({
        registerContainerRef: this.registerContainerRef,
        fetchWidget: this.requestWidget,
        onUpdateSize: this.onIframeResize,
        onUpdateOpened: this.onOpenUpdate,
        onHideWelcomeMessage: this.hideWelcomeMessage
      }, this.props));
    }
  }]);

  return ApplicationContainer;
}(_react.Component);

ApplicationContainer.propTypes = {
  receivedWidgetData: _react.PropTypes.func.isRequired,
  push: _react.PropTypes.func.isRequired,
  leaveChannels: _react.PropTypes.func.isRequired,
  setWindowVisible: _react.PropTypes.func.isRequired,
  toggleOpen: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var prospectUtks = _ref2.prospectUtks,
      requestStatus = _ref2.requestStatus;

  return {
    prospectUtks: prospectUtks,
    requestStatus: requestStatus
  };
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push,
  leaveChannels: _PubNubPresenceActions.leaveChannels,
  setWindowVisible: _WindowActions.setWindowVisible,
  receivedWidgetData: _WidgetActions.receivedWidgetData,
  toggleOpen: _WidgetActions.toggleOpen
};

exports.default = (0, _pipe2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _Checker.checker)({
  selectors: {
    success: _defineProperty({}, _Reagan.CHECKS.VISITOR_SUCCESS, _Reagan.SELECTORS.VISITOR_SUCCESS),
    error: _defineProperty({}, _Reagan.CHECKS.VISITOR_ERROR, _Reagan.SELECTORS.VISITOR_ERROR)
  }
}))(ApplicationContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/containers/ApplicationContainer.js
// module id = 554
// module chunks = 0